export enum GoalType {
  LOSE_WEIGHT = 1,
  GAIN_WEIGHT = 2,
}
